import { render, staticRenderFns } from "./ModalDialogTrigger.vue?vue&type=template&id=4d429f17"
import script from "./ModalDialogTrigger.vue?vue&type=script&lang=js"
export * from "./ModalDialogTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports